<template>
  <a-modal
    ref="createModal"
    title="新建车间"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: 800, y: 260 }"
    >
      <!-- 车间类型 -->
      <span slot="workshopTypeTitle">
        <i class="toRequired">*</i>车间类型
      </span>
      <template slot="workshopType" slot-scope="text, record">
        <a-select v-model="record.workshopType">
          <a-select-option v-for="(item) in workshopTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
        </a-select>
      </template>
      <!-- 加工组织 -->
      <span slot="organizationCodeTitle">
        <i class="toRequired">*</i>加工组织
      </span>
      <span slot="organizationCode" slot-scope="text, record" class="organizationCode">
        <global-select
          :value.sync="record.organizationCode"
          selectType="selectAssembleSearch"
          requestApi="/system/user/inventOrgList"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :dropdown-match-select-width="false"
          :allowClear="false"
          :assembleLabel="true"
          searchParam="organizationName"
          :setParams="{ pageSize: 9999999 }"
          @change="getJobClassPullDownList(record)"
        />
      </span>
      <!-- 车间编码 -->
      <span slot="workshopCodeTitle">
        <i class="toRequired">*</i>车间编码
      </span>
      <template slot="workshopCode" slot-scope="text, record">
        <a-input v-model="record.workshopCode" />
      </template>
      <!-- 零部件类型 -->
      <template slot="ljZcbcpType" slot-scope="text, record">
        <global-select
          :value.sync="record.ljZcbcpType"
          :selectData="partsList"
          selectType="selectFilter"
          :allowClear="true"
          @change="(val) => partsChange(val, text.record)"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
      </template>
      <!-- 车间说明 -->
      <span slot="workshopDescTitle">
        <i class="toRequired">*</i>车间说明
      </span>
      <template slot="workshopDesc" slot-scope="text, record">
        <a-input v-model="record.workshopDesc" />
      </template>
      <!-- 财务车间编码 -->
      <template slot="finWorkCode" slot-scope="text, record">
        <a-input v-model="record.finWorkCode" :maxLength="100" />
      </template>
      <!-- 车间物控 -->
      <template slot="workshopMcName" slot-scope="text, record">
        <!-- <a-select v-model="record.workshopMcName">
          <a-select-option v-for="(item) in workshopMcNameList" :key="item.realValue">{{ item.label }}</a-select-option>
        </a-select> -->
        <global-select
          class="workshop-mc-name-selector"
          :value.sync="record.workshopMcName"
          selectType="selectAssembleSearch"
          @change="(val, selectList)=>workshopMcNameChange(val, selectList, record)"
          requestApi="/bom/bomWorkshop/findWorkshopMc"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="inputString"
        />
      </template>
      <!-- 默认工单分类 -->
      <span slot="defaultJobClassTitle">
        <i class="toRequired">*</i>默认工单分类
      </span>
      <template slot="defaultJobClass" slot-scope="text, record">
        <a-select v-model="record.defaultJobClass">
          <a-select-option v-for="(item) in defaultJobClassList" :key="item.realValue">{{ item.label }}</a-select-option>
        </a-select>
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { apiBomWorkshopAdd, apiJobClassPullDownList } from '@/api/mes/basedata/factoryAssembly'
// 表单字段
export default {
  props: {
    inventOrg: {
      type: Array,
      default: () => {
        return []
      }
    },
    workshopTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    partsList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '车间类型',
          dataIndex: 'workshopType',
          width: 150,
          scopedSlots: { customRender: 'workshopType', title: "workshopTypeTitle" }
        },
        {
          // title: '加工组织',
          dataIndex: 'organizationCode',
          width: 180,
          scopedSlots: { customRender: 'organizationCode', title: "organizationCodeTitle" }
        },
        {
          title: '零部件类型',
          width: 150,
          dataIndex: 'ljZcbcpType',
          scopedSlots: { customRender: 'ljZcbcpType' }
        },
        {
          // title: '车间编码',
          width: 150,
          dataIndex: 'workshopCode',
          scopedSlots: { customRender: 'workshopCode', title: "workshopCodeTitle" }
        },
        {
          // title: '车间说明',
          width: 150,
          dataIndex: 'workshopDesc',
          scopedSlots: { customRender: 'workshopDesc', title: "workshopDescTitle" }
        },
        {
          title: '财务车间编码',
          dataIndex: 'finWorkCode',
          width: 170,
          scopedSlots: { customRender: 'finWorkCode' }
        },
        {
          title: '车间物控',
          dataIndex: 'workshopMcName',
          width: 170,
          scopedSlots: { customRender: 'workshopMcName' }
        },
        {
          // title: '默认工单分类',
          dataIndex: 'defaultJobClass',
          width: 150,
          scopedSlots: { customRender: 'defaultJobClass', title: "defaultJobClassTitle" }
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      typeList: [],
      // workshopMcNameList: [], // 车间物控(缺接口数据)
      defaultJobClassList: [] // 默认工单分类
    }
  },
  created () {},
  methods: {
    // 零部件类型选择
    partsChange(val, record) {
      const selectedElement = this.partsList?.find(item => item.lookupCode === val)
      // record.ljZcbcpType = selectedElement?.realValue || ''
      record.ljZcbcpTypeName = selectedElement?.lookupValue || ''
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        workshopType: "",
        organizationCode: "",
        workshopCode: "",
        workshopDesc: "",
        workshopMcName: "",
        defaultJobClass: "",
        workshopStatus: "Y",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].workshopType || !this.typeList[i].organizationCode || !this.typeList[i].workshopCode || !this.typeList[i].workshopDesc || !this.typeList[i].defaultJobClass) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiBomWorkshopAdd(this.typeList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    },
    // 默认工单分类
    getJobClassPullDownList (record) {
      record.defaultJobClass = ""
      const arr = []
      arr.push(record.organizationCode)
      apiJobClassPullDownList({ organizationCodeList: arr }).then(res => {
        if (res.data && res.data.length > 0) {
          this.defaultJobClassList = res.data
        } else {
          this.defaultJobClassList = []
        }
      })
    },
    // 车间物控
    workshopMcNameChange (val, selectList, record) {
      const selectedElement = selectList.find(item => item.realValue === val);
      if (selectedElement) {
        record.workshopMcName = selectedElement.realValue
        record.workshopMcCode = selectedElement.label
      }
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
input{
  width: 120px !important;
}
/deep/.ant-input-number{
  width: 100px !important;
}
/deep/.ant-select{
  width: 120px !important;
}
.workshop-mc-name-selector {
  /deep/.ant-select{
    width: 140px !important;
  }
}
.organizationCode{
  /deep/.ant-select{
    width: 170px !important;
  }
}
</style>
